import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  trigger: {
    border: "1px solid transparent",
    '& .MuiSvgIcon-root path': {
      fill: palette.shades[600]
    }
  }
});
export default useStyles;